/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Enables the AI email assistant on the tenant helpdesk inbox. Off when absent. The global CAREY_EMAIL_ENABLED config remains the deployment-wide kill switch; both must be on.
 * @export
 * @interface CareyEmailModule
 */
export interface CareyEmailModule {
    /**
     * 
     * @type {boolean}
     * @memberof CareyEmailModule
     */
    enabled?: boolean;
}

/**
 * Check if a given object implements the CareyEmailModule interface.
 */
export function instanceOfCareyEmailModule(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CareyEmailModuleFromJSON(json: any): CareyEmailModule {
    return CareyEmailModuleFromJSONTyped(json, false);
}

export function CareyEmailModuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): CareyEmailModule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
    };
}

export function CareyEmailModuleToJSON(value?: CareyEmailModule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
    };
}

